import Head from 'next/head';
import { type FC } from 'react';
import { AuthTransition } from '@/Module/Auth/Component';
import { preparePageTitle } from '@/Module/Core/Helper';
import { useAppSelector } from '@/Module/Store/Hook';
const Transition: FC = () => {
  const isTransitioning = useAppSelector(state => state.auth.isTransitioning);
  if (!isTransitioning) return null;
  return <>
      <Head data-sentry-element="Head" data-sentry-source-file="Transition.tsx">
        <title>{preparePageTitle('انتقال')}</title>
      </Head>

      <div className="z-[100] flex h-screen items-center justify-center">
        <AuthTransition data-sentry-element="AuthTransition" data-sentry-source-file="Transition.tsx" />
      </div>
    </>;
};
export default Transition;